import { ELEMENT_NAVBAR, useDreamEditorState } from '@typedream/dream-editor';
import OriginalEmptyGuide from '@/sharedComponents/TextEditor/components/EmptyGuide';
import { DreamBlock, DreamEditor, DreamValue } from '@/sharedComponents/TextEditor/plate';
import { isEditorFocused } from '@udecode/plate-core';
import { useMemo, useState, useEffect } from 'react';
import isContentEqualNoID from '@/sharedComponents/TextEditor/utils/isContentEqualNoID';
import { initialValueEmpty } from '@/sharedComponents/TextEditor';
import { pick } from 'lodash';

export function EmptyGuide() {
  const editor = useDreamEditorState();

  const [isShown, setIsShown] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const isNavbarExist = useMemo(() => {
    const currentValue = editor.children as unknown as DreamValue;
    return !isContentEqualNoID(currentValue, initialValueEmpty);
  }, [editor.children]);

  useEffect(() => {
    const onInsideDropdownMenuhandler = ({ isInside }: { isInside: boolean }) => {
      setIsDropdownOpen(isInside);
    };
    editor.emitter.on('toolbar:toggle-navbar-container-inside-dropdown', onInsideDropdownMenuhandler);
    return () => {
      editor.emitter.off('toolbar:toggle-navbar-container-inside-dropdown', onInsideDropdownMenuhandler);
    };
  }, [editor]);

  const handle = (e: typeof editor) => {
    const currentValue = e.children as unknown as DreamValue;

    const currentValueExceptNavbar = currentValue.map((cv) => {
      const newItemCurrentValue = pick<DreamBlock>({ ...cv }, ['type', 'children']);

      if (newItemCurrentValue.children.length) {
        newItemCurrentValue.children = cv.children.filter((c) => c.type !== ELEMENT_NAVBAR);
      }
      return newItemCurrentValue as DreamBlock;
    });

    const isContentEmpty = isContentEqualNoID(currentValueExceptNavbar, initialValueEmpty);
    setIsShown((
      (!editor.selection && isContentEmpty)
      || (isContentEmpty && !isEditorFocused(e))));
  };

  requestIdleCallback(() => {
    handle(editor);
  });

  if (!isShown || isDropdownOpen) return null;

  return (
    <OriginalEmptyGuide
      editor={editor as unknown as DreamEditor}
      isNavbarExist={isNavbarExist}
    />
  );
}
